import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountService } from 'src/app/services/account/account.service';
import { ConsoleLoggerService } from 'src/app/services/logging/console-logger.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { MapService, ShowOnMapEnum } from 'src/app/services/map/map.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { HistoryElement } from '../../../models/history';
import { TurnValueIntegerThousandsPipe } from 'src/app/pipes/turn-value-integer-thousands.pipe';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-history-panel',
  templateUrl: './history-panel.component.html',
  imports: [TurnValueIntegerThousandsPipe, DatePipe, CommonModule],
  styleUrls: ['./history-panel.component.scss']
})
export class HistoryPanelComponent implements OnInit {

  @Input() history: HistoryElement | null = null;
  @Output() loadingHistoryChanged = new EventEmitter();

  constructor(private consoleLoggerService: ConsoleLoggerService, public settingsService: SettingsService,
    private mapService: MapService, public accountService: AccountService,
    public languageService: LanguageService) {
  }

  ngOnInit(): void {
    this.loadingHistoryChanged.emit(true);
    if (this.history !== null) {
      this.accountService.getTrack(this.history.id).subscribe((resp)=>{
        this.mapService.ObservableDrawTripToMap.next(resp);
        this.loadingHistoryChanged.emit(false);
      });
    } else {
      this.loadingHistoryChanged.emit(false);
    }
  }

  public goBack(): void {
    this.mapService.ObservableShowOnMap.next({ type: ShowOnMapEnum.BackHistory, data: history });
  }
}
